import { Component, OnInit } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../core/security/user.service';
import { LeftPanelService } from '../../../../../layout/home/services/left-panel.service';
import { DatePickerConfigService } from '../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-commodity-search',
  templateUrl: './commodity-primary-accordian.component.html',
  styleUrls: ['./commodity-primary-accordian.component.css']
})

export class  CommodityPrimaryAccordianComponent extends AbstractFormWidgetComponent implements OnInit {

  public accordionLine2: Array<any> = ['style', 'color', 'size', 'measurement', 'packKey'];
  public accordionLine3: Array<any> = ['putcode', 'skuStatus', 'cartonGroup', 'stdGrosswgt', 'stdNetwgt'];
  public accordionLine4: Array<any> = ['stdCube', 'skuGroup', 'abc', 'strategyKey'];
  public accordionLine5: Array<any> = ['class', 'itemClass', 'manufacturerSku', 'retailSku', 'altSku'];
  public accordionLine6: Array<any> = ['cube', 'grossWgt', 'netWgt', 'lengthProp'];
  public accordionLine7: Array<any> = ['widthProp', 'heightProp', 'weightProp', 'stackFactor', 'countryofOrigin'];

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService,
        alertService, userService, dateConfigService);
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/commodity/commodity-primary-accordian/commodity-primary-accordian.component.ts